// src/lib/utils.ts
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export formatRelativeAge from central dateUtils for backward compatibility
// New code should import from '@/utils/dateUtils' directly
export { formatRelativeAge, formatRelativeAgeVerbose } from '../utils/dateUtils';